import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import LanguageToggle from "../LanguageToggle/LanguageToggle";
import StyleContext from "../../contexts/StyleContext";
import usePortfolioContent from "../../hooks/usePortfolioContent";

function Header() {
  const {isDark} = useContext(StyleContext);
  const {nav, workExperiences, educationInfo, bigProjects, skillsShowcase, achievementSection} =
    usePortfolioContent();

  const viewExperience = workExperiences.display;
  const viewEducation = educationInfo.display;
  const viewProjects = bigProjects.display;
  const viewSkills = skillsShowcase.display;
  const viewAchievement = achievementSection.display;

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">Talal Ahmed</span>
          <span className="grey-color">/&gt;</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {viewExperience && (
            <li>
              <a href="#experience">{nav.experience}</a>
            </li>
          )}
          {viewEducation && (
            <li>
              <a href="#education">{nav.education}</a>
            </li>
          )}
          {viewProjects && (
            <li>
              <a href="#projects">{nav.projects}</a>
            </li>
          )}
          {viewSkills && (
            <li>
              <a href="#skills">{nav.skills}</a>
            </li>
          )}
          {viewAchievement && (
            <li>
              <a href="#achievements">{nav.achievements}</a>
            </li>
          )}
          <li>
            <a href="#contact">{nav.contact}</a>
          </li>
          <li>
            <LanguageToggle />
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
